import type { UiIconId } from "@/lib/game/uiIcons";
import { UI_ICONS } from "@/lib/game/uiIcons";

export type GameTone = "violet" | "sky" | "amber" | "rose" | "indigo" | "emerald" | "slate";

interface GameIconProps {
  icon: UiIconId;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const SIZE_CLASS = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-4xl",
  xl: "text-5xl",
} as const;

/** Renders a placeholder emoji icon. Replace with illustrated assets via `UI_ICONS[id].asset`. */
export function GameIcon({ icon, size = "md", className = "" }: GameIconProps) {
  const def = UI_ICONS[icon];
  if (def.asset) {
    return (
      <img
        src={def.asset}
        alt=""
        aria-hidden
        className={`object-contain ${className}`}
        draggable={false}
      />
    );
  }
  return (
    <span className={`leading-none select-none ${SIZE_CLASS[size]} ${className}`} aria-hidden>
      {def.emoji}
    </span>
  );
}

export function iconLabel(icon: UiIconId): string {
  return UI_ICONS[icon].label;
}
